import Box from '@mui/system/Box';
import DefaultButton from 'app/shared-components/layout/DefaultButton';
import TitledPanel from './TitledPanel';

function EntityForm({title, submitTitle, handleSubmit, onSubmit, onClose, returnPath, isValid, dirtyFields, children, onHelpClick}) {

  return (
    <>
      <TitledPanel title={title} returnPath={returnPath} onClose={onClose} onHelpClick={onHelpClick}>
        
        {children}    
          				 
      </TitledPanel>
      
      <Box
          className="flex items-center mt-40 py-14 pr-16 pl-4 sm:pr-48 sm:pl-36 border-t"
          sx={{ backgroundColor: 'background.default' }}
       >
         {onClose ?
           <DefaultButton text="Cancel" onClick={onClose} />
           :
           <DefaultButton text="Cancel" link={-1} />
         }
          
          <DefaultButton text={submitTitle} 
                         disabled={_.isEmpty(dirtyFields) || !isValid}
                         onClick={handleSubmit(onSubmit)}/>
      </Box>

    </>
  );
}

export default EntityForm;
